import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async update(id, form) {
    await Csrf.getCookie();

    return Api.patch("/tasks/" + id, form);
  },

  async index() {
    await Csrf.getCookie();

    return Api.get("/tasks/list/dashboard");
  },

  async indexWithParams(serverparams) {
    await Csrf.getCookie();

    return Api.post("/tasks/list/table", serverparams);
  },

  async locationLeadAccept(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/location_lead_accept");
  },

  async onePersonAccept(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/one_person_accept");
  },

  async projectLeadAccept(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/project_lead_accept");
  },

  async setClosable(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set_closable", form);
  },

  async unplugs() {
    await Csrf.getCookie();

    return Api.get("/tasks/unplugs");
  },

  async simple() {
    await Csrf.getCookie();

    return Api.get("/tasks/simple");
  },

  async add(form) {
    await Csrf.getCookie();

    return Api.post("/tasks", form);
  },

  async appendComment(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/append-comment", data);
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/tasks/" + id);
  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id);
  },

  async showTaskPositions(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/task_positions");
  },

  async showComments(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/comments");
  },

  async showPermitTypes(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/permit_types");
  },

  async showIsolations(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/isolations");
  },

  async showBoxes(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/boxes");
  },

  async setElectricians(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-electricians", data);
  },

  async setPositionLock(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-position-lock", data);
  },

  async freePositionLock(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/free-position-lock", data);
  },

  async setBoxLock(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-box-lock", data);
  },

  async freeBoxLock(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/free-box-lock", data);
  },

  async setBoxKey(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-box-key", data);
  },

  async freeBoxKey(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/free-box-key", data);
  },

  async loadForCopying(id, copyMode) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/load-for-copying/" + copyMode);
  },

  async setOperator(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-operator", form);
  },

  async setDdcUser(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-ddc-user", form);
  },

  async setBlackLockUser(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-black-lock-user", form);
  },

  async setOwnerFinish(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-owner-finish", form);
  },

  async setLocationLeaderFinish(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-location-leader-finish", form);
  },

  async updateOperator(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/update-operator", form);
  },
  async updateOwner(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/update-owner", form);
  },
  async updateLocationLeader(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/update-location-leader", form);
  },

  async readyForEvaluation(id) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/ready-for-evaluation", {});
  },

  async undoEvaluationSend(id) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/undo-evaluation-send", {});
  },

  async locationLeadDecline(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/location_lead_decline", form);
  },

  async setElectriciansAndLocks(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-electricians-and-locks", form);
  },

  async setLocks(id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-locks", form);
  },

  async positionUpdateToTask(id, form) {
    await Csrf.getCookie();

    return Api.post("tasks/" + id + "/position-update-to-task", form);
  },

  async signPermitWithPin(form) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/sign-with-pin", form);
  },

  async signLoggedIn(form) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/sign-logged-in", form);
  },

  async signByCoordination(form) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/sign-by-coordination", form);
  },

  async signPermitWithEmail(form) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/sign-with-email", form);
  },

  async addPermit(form) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits", form);
  },

  async deletePermit(id) {
    await Csrf.getCookie();

    return Api.delete("/tasks/permits/" + id);
  },

  async getPermitForm(task_id, id) {
    await Csrf.getCookie();

    return Api.get("/tasks/permits/" + task_id + "/" + id);
  },

  async sendPermitForm(task_id, id, form) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/" + task_id + "/" + id, form);
  },

  async movePermitStatus(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/" + id + "/move-permit-status", data);
  },

  async sendForSign(task_permit_type_id, data) {
    await Csrf.getCookie();

    return Api.post(
      "/tasks/permits/" + task_permit_type_id + "/send-for-sign",
      data
    );
  },

  async getUserSign(task_permit_type_id) {
    await Csrf.getCookie();

    return Api.get("/tasks/permits/" + task_permit_type_id + "/get-user-sign");
  },

  async permitExtend(id, permit_type_id, data) {
    await Csrf.getCookie();

    return Api.post(
      "/tasks/permits/" + id + "/" + permit_type_id + "/extend",
      data
    );
  },

  async getTaskPermitTypeValidityRecords(task_id, id) {
    await Csrf.getCookie();

    return Api.get(
      "/tasks/permits/" + task_id + "/" + id + "/validity-records"
    );
  },

  async getTaskValidityRecords(task_id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + task_id + "/validity-records");
  },

  async addPositionToTask(task_id, position_id) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + task_id + "/add-position-to-task", {
      position_id: position_id,
    });
  },

  async addPermitTypeToTask(task_id, permit_type) {
    await Csrf.getCookie();

    return Api.post("/tasks/permits/" + task_id + "/add-permit-type-to-task", {
      permit_type: permit_type,
    });
  },

  async deletePermitType(task_permit_type_id) {
    await Csrf.getCookie();

    return Api.delete("/tasks/permits/" + task_permit_type_id + "/delete");
  },

  async extendTask(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/extend", data);
  },

  async checkNextStatusTerms(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/check-next-status");
  },

  async setLocationLeader(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/set-location-leader", data);
  },

  async fnProbeDetails(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/fn-probe-details");
  },

  async storeAreaPermit(id, data) {
    await Csrf.getCookie();

    return Api.post("/tasks/" + id + "/permits/area", data);
  },

  async hasBlackLocksReturned(id) {
    await Csrf.getCookie();

    return Api.get("/tasks/" + id + "/has-black-locks-returned");
  },
};
